<template>
  <div ref="allpage" class="packPage">
    <search-modal ref="search" style="position: fixed; top: 0; width: 100%; z-index: 999" @toserch="toserch" />
    <md-tabs style="margin-top: 1rem" @change="changetable" v-model="indename">
      <md-tab-pane class="contentpack" name="0" :label="items[0].label" style="position: relative">
        <div style="height: 1.2rem"></div>
        <v-refresh :on-refresh="onRefreshone">
          <v-reload :on-infinite-load="infinite" :parent-pull-up-state="infiniteLoadData.pullUpState">
            <div v-if="list[0].packlist.length > 0" class="packcontainer">
              <div v-for="(item, index) in list[0].packlist" :key="index" class="packItem">
                <div class="packcompany">
                  <div class="packtitle" style="padding-left: 0.2rem">
                    <!--                    <img-->
                    <!--                      src="@/assets/image/icon_pack_drk.png"-->
                    <!--                      alt=""-->
                    <!--                    />-->
                    <span style="font-size: 0.28rem">{{ item.warehouse }}</span>
                  </div>
                  <span>待入庫</span>
                </div>
                <div class="pckdetail fidays">
                  <p>
                    快遞單號：
                    <span v-if="item.expressCompany">{{ item.expressCompany }}-{{ item.expressNumber }}</span>
                    <span v-else>{{ item.expressNumber }}</span>
                  </p>
                  <p v-if="item.remark">
                    包裹标注：
                    <span>{{ item.remark }}</span>
                  </p>
                  <p>
                    货物类型：
                    <span v-if="item.type === 0" style="color: #2a78dc">普货</span>
                    <span v-else style="color: orangered">特货</span>
                  </p>
                  <p>
                    包裹總值：
                    <md-amount :value="item.totalPrice" has-separator></md-amount>
                    CNY
                  </p>
                  <p style="margin-bottom: 0;">
                    預報時間：<span>{{
                      item.createTime | dateformat("YYYY-MM-DD HH:mm")
                      }}</span>
                  </p>
                  <div class="parcel_detail_container">
                    <p style="margin-top: 0.05rem;">包裹明細：</p>
                    <div class="tag_container">
                      <div v-for="(tag, tagIndex) in item.list" class="usnenr" :key="tagIndex">
                        <span>{{ tag.name }}x{{ tag.num }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="packopeartion">
                  <div class="appbutone" @click="detail(item)" v-if="item.status == 1"
                    style="border-color: #2a78dc;color: #2a78dc">
                    <span>編輯</span>
                  </div>
                  <div class="appbutone" @click="delet(item, index)" v-if="item.status == 1"
                    style="border-color: #ff5257;color: #ff5257">
                    <span>删除</span>
                  </div>

                  <div class="appbutone" @click="chenkjfr(item)" v-if="item.status == 2"
                    style="border-color: #2a78dc;color: #2a78dc">
                    <span>撤銷拒收</span>
                  </div>
                  <div class="appbutone" @click="lanjie(item)" v-if="item.status == 1 || item.status == 3"
                    style="border-color: #2a78dc;color: #2a78dc">
                    <span>拒收拦截</span>
                  </div>
                </div>
              </div>
            </div>
            <noth-modal v-else></noth-modal>
            <div style="width: 100%; height: 3.4rem"></div>
          </v-reload>
        </v-refresh>
      </md-tab-pane>
      <md-tab-pane class="contentpack" name="1" :label="items[1].label">
        <div style="height: 1.1rem"></div>
        <v-refresh :on-refresh="onRefreshone">
          <v-reload :on-infinite-load="infinite" :parent-pull-up-state="infiniteLoadData.pullUpState">
            <md-drop-menu :data="warehouses" v-if="warehouses[0].options.length > 0" @change="changeWareHouse" />
            <div v-if="list[1].packlist.length > 0" class="packcontainer">
              <div v-for="(item, index) in list[1].packlist" :key="index" class="packItem">
                <div class="packcompany" @click="godetail(item)">
                  <div class="packtitle">
                    <!--                      <img src="@/assets/image/icon_pack_drk.png" alt=""/>-->
                    <span style="margin-left: 0.5rem;color:black;font-size: 0.28rem ">{{ item.warehouse }}</span>
                    <div class="packageTyps" v-if="item.type == 1" style="margin-left: 5px">
                      <span>特货</span>
                    </div>
                    <div class="packageTyp" v-if="item.type != 1" style="margin-left: 5px">
                      <span>普货</span>
                    </div>
                    <div class="packageTyps" v-if="item.goodsType">
                      <span>{{ item.goodsType }}</span>
                    </div>
                    <div class="packageTyps" v-if="item.isParcelUnpack === false">
                      <span>不拆</span>
                    </div>
                  </div>
                  <span v-if="item.status == 11" style="color: #32c5ea">待補資料</span>
                  <span v-if="item.status == 12">待合包</span>
                  <span v-if="item.status == 13" style="color: #e51c23">超期</span>
                  <span v-if="item.status == 14" style="color: #32c5ea">待補資料</span>
                </div>

                <div style="display: flex">
                  <div @click="handCheck(index)"
                    v-if="(item.status == 12 || item.status == 13) && item.auditStatus != 0"
                    style="display: flex;align-items: center;justify-content: center">
                    <md-icon name="check" v-if="!item.check" class="checkbtn" size="lg" />
                    <md-icon name="checked" color="#e51c23" v-if="item.check" class="checkbtn" size="lg" />
                  </div>
                  <div v-else style="width: 0.6rem"></div>
                  <div class="pckdetail" @click="godetail(item)" style="padding-left: 0.2rem">
                    <p style="width: 6.1rem;display: flex;justify-content: space-between;color: rgba(79, 79, 79, 1);">
                      <span v-if="item.expressCompany">{{ item.expressCompany }}-{{
                        item.expressNumber
                      }}</span>
                      <span v-else>{{ item.expressNumber }}</span>
                      <span v-if="item.check && showCheck === 1">計費重:
                        <md-amount :value="item.bulk" has-separator></md-amount>kg
                      </span>
                      <span v-else>實重:<md-amount :value="item.weight" has-separator></md-amount>kg</span>
                    </p>
                    <p v-if="item.remark" style="font-size: 0.24rem;margin-top: 0.05rem">
                      包裹备注:
                      <span>{{ item.remark }}</span>
                    </p>
                    <div class="parcel_detail_container">
                      <div class="tag_container">
                        <div v-for="(tag, tagIndex) in item.list" class="usnenr" :key="tagIndex">
                          <span>{{ tag.name }}x{{ tag.num }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="packopeartion" style="justify-content: space-between">
                  <p style="font-size: 0.24rem;margin-left: 0.8rem;color: rgba(154, 154, 154, 1);">入庫时间:<span>{{
                    item.deliveryTime | dateformat("YYYY-MM-DD")
                      }}</span>
                  </p>
                  <div style="display: flex">
                    <div class="appbutone" v-if="item.status == 11 || item.status == 14" @click="godetail(item)">
                      <span>补全信息</span>
                    </div>
                    <div class="appbutone" @click="returnpack(item)">
                      <span>退貨</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <noth-modal v-else></noth-modal>
            <div style="width: 100%; height: 3.2rem"></div>
          </v-reload>
        </v-refresh>
      </md-tab-pane>
      <md-tab-pane class="contentpack" name="2" :label="items[2].label">
        <div style="height: 1.2rem"></div>
        <v-refresh :on-refresh="onRefreshone">
          <v-reload :on-infinite-load="infinite" :parent-pull-up-state="infiniteLoadData.pullUpState">
            <div v-if="list[2].packlist.length > 0" class="packcontainer">
              <div v-for="(item, index) in list[2].packlist" :key="index" class="packItem">
                <div class="packcompany">
                  <div class="packtitle" style="padding-left: 0.2rem">
                    <div class="packageTyp" v-if="item.type == 1">
                      <span>特</span>
                    </div>
                    <span style="font-size: 0.28rem">{{ item.warehouse }}</span>
                  </div>
                  <span v-if="item.status == 21" style="color: #e51c23">[拒收]尺寸超标</span>
                  <span v-if="item.status == 22" style="color: #e51c23">[拒收]包裹超重</span>
                  <span v-if="item.status == 23" style="color: #e51c23">[拒收]违禁物品</span>
                  <span v-if="item.status == 24" style="color: #e51c23">[拒收]涉嫌侵权</span>
                </div>
                <div class="pckdetail fidays" @click="godetail(item)">
                  <p>
                    快遞單號：<span v-if="item.expressCompany">{{ item.expressCompany }}-{{ item.expressNumber }}</span>
                    <span v-else>{{ item.expressNumber }}</span>
                  </p>
                  <p v-if="item.remark">
                    包裹标注：
                    <span>{{ item.remark }}</span>
                  </p>
                  <p>
                    實重：
                    <md-amount :value="item.weight" has-separator style="margin-left: 0.5rem"></md-amount>
                    KG
                  </p>
                  <p>
                    拒收時間：<span>{{
                      item.deliveryTime | dateformat("YYYY-MM-DD HH:mm")
                      }}</span>
                  </p>
                </div>
                <div class="packopeartion">
                  <div class="appbutone" @click="deletyichang(item)" style="border-color: #ff5257;color: #ff5257">
                    <span>删除</span>
                  </div>
                </div>
                <div class="packopeartion" style="height: 0.05rem"></div>
              </div>
            </div>
            <noth-modal v-else></noth-modal>
            <div style="width: 100%; height: 2.5rem"></div>
          </v-reload>
        </v-refresh>
      </md-tab-pane>
      <md-tab-pane class="contentpack" name="3" :label="items[3].label">
        <div style="height: 1.2rem"></div>
        <v-refresh :on-refresh="onRefreshone">
          <v-reload :on-infinite-load="infinite" :parent-pull-up-state="infiniteLoadData.pullUpState">
            <div v-if="list[3].packlist.length > 0" class="packcontainer">
              <div v-for="(item, index) in list[3].packlist" :key="index" class="packItem">
                <div class="packcompany">
                  <div class="packtitle" style="padding-left: 0.2rem">
                    <div class="packageTyp" v-if="item.type == 1">
                      <span>特</span>
                    </div>
                    <span style="font-size: 0.28rem">{{ item.warehouse }}</span>
                  </div>
                  <span v-if="item.status == 31" style="color: #e51c23">已合包</span>
                  <span v-if="item.status == 32" style="color: #e51c23">已销毁</span>
                  <span v-if="item.status == 33" style="color: #e51c23">退货中</span>
                  <span v-if="item.status == 34" style="color: #e51c23">退货完成</span>
                </div>
                <div class="pckdetail fidays" @click="godetail(item)">
                  <p>
                    快遞單號：<span v-if="item.expressCompany">{{ item.expressCompany }}-{{ item.expressNumber }}</span>
                    <span v-else>{{ item.expressNumber }}</span>
                  </p>
                  <p v-if="item.remark">
                    包裹标注:
                    <span>{{ item.remark }}</span>
                  </p>
                  <p>
                    計費重：
                    <md-amount :value="item.bulk" has-separator style="margin-left: 0.19rem"></md-amount>
                    KG
                  </p>
                  <div class="parcel_detail_container">
                    <p style="margin-top: 0.05rem;">包裹明細：</p>
                    <div class="tag_container">
                      <div v-for="(tag, tagIndex) in item.list" class="usnenr" :key="tagIndex">
                        <span>{{ tag.name }}x{{ tag.num }}</span>
                      </div>
                    </div>
                  </div>
                  <p v-if="item.status < 21 || item.status > 24">
                    入庫時間：<span>{{
                      item.deliveryTime | dateformat("YYYY-MM-DD HH:mm")
                      }}</span>
                  </p>
                  <p v-if="item.status >= 21 && item.status <= 24">
                    拒收時間：<span>{{
                      item.deliveryTime | dateformat("YYYY-MM-DD HH:mm")
                      }}</span>
                  </p>
                  <p style="padding-bottom: 0.1rem">
                    合包時間：<span>{{
                      item.updateTime | dateformat("YYYY-MM-DD HH:mm")
                      }}</span>
                  </p>
                </div>
              </div>
              <div class="packopeartion" style="height: 0.1rem"></div>
            </div>
            <noth-modal v-else></noth-modal>
            <div style="width: 100%; height: 2.5rem"></div>
          </v-reload>
        </v-refresh>
      </md-tab-pane>
    </md-tabs>
    <md-button type="warning" style="position: fixed; bottom: 1.2rem; width: 94%; margin-left: 3%" v-if="current == '0'"
      @click="toprediction">包裹預報
    </md-button>
    <div style="height:1rem" v-if="current == '1'"></div>
    <div class="fixchedk" v-if="current == '1'">
      <div class="checkView" @click="handShow()">
        <span v-if="showCheck === 0">實重</span>
        <span v-if="showCheck === 1">計費重</span>
        <md-icon name="arrow-down" :svg="false" size="xs"></md-icon>
      </div>
      <span class="shotips" v-if="showCheck === 0">合单以计费重核算，此处可切换计算</span>
      <div v-if="showCheck === 1" style="height: 100%;display: flex;align-items: center">
        <div class="jifensjer" @click="isPickerShow2 = true">
          <span v-if="volumList.length">{{ volumList[volumNUm].productName }}</span>
          <span v-else>請選擇線路</span>
          <md-icon name="arrow-down" :svg="false" size="xs"></md-icon>
        </div>
        <span class="shotips" v-if="volumList.length && volumList[volumNUm].isBubbles == 1">计抛基数{{
          volumList[volumNUm].
            volumeDivision }}</span>
        <span v-else class="shotips">不计抛</span>
      </div>
    </div>
    <div v-if="current == '1'" class="bottomView">

      <div class="checkall">
        <md-icon name="check" size="lg" v-if="!checkedall" @click="checkall" />
        <md-icon name="checked" size="lg" v-else style="color: rgb(229, 28, 35)" @click="checkall" />
        <span @click="checkall">全选</span>
      </div>
      <div class="chelist">
        <div class="cancle">
          <p>
            <span style="color: #222222">已选{{ favorites.length }}件</span>
            <span>
              <span v-if="showCheck === 0">實重合計：</span>
              <span v-if="showCheck === 1">計費重合計：</span>
              <span class="money">{{ total }}KG</span>
            </span>

          </p>
        </div>
        <span style="font-size: 0.22rem;color: #2a78dc" @click="handReturn">国内退货</span>
        <md-button :type="favorites.length > 0 ? 'warning' : 'disabled'" style="width: 1.8rem" @click="submit">提交
        </md-button>
      </div>
    </div>
    <div style="width: 100%; height: 1.2rem"></div>
    <md-selector v-model="isPickerShow2" :data="showLinedata" :default-value="volumNUm" large-radius title="請選擇線路"
      :is-check="true" class="cheklist" @choose="onPickerConfirm2"></md-selector>
    <md-selector v-model="isPickerShow1" :data="[{
      text: '實重',
      value: 0
    }, {
      text: '計費重',
      value: 1
    }]" large-radius hide-title-bar :default-value="showCheck" class="cheklist" :is-check="true"
      @choose="onPickerConfirm"></md-selector>
  </div>
</template>
<script>
import {
  Button,
  Icon,
  Tabs,
  TabPane,
  Selector,
  Toast,
  Check,
  CheckGroup,
  Amount,
  Dialog,
  Tag,
  DropMenu,
} from "mand-mobile";
import NothModal from "../Modal/NothModal";
import SearchModal from "../package/Modal/SearchModal";
import DropDownRefresh from "../../components/refresh";
import PullUpReload from "../../components/pullDown";

export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Selector.name]: Selector,
    [Dialog.name]: Dialog,
    [Amount.name]: Amount,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Check.name]: Check,
    [CheckGroup.name]: CheckGroup,
    [Tag.name]: Tag,
    [DropMenu.name]: DropMenu,
    SearchModal,
    "v-refresh": DropDownRefresh,
    "v-reload": PullUpReload,
    NothModal,
  },
  name: "Package",
  data() {
    return {
      inStatus: '',
      showCheck: 0,
      volumList: [],
      showLinedata: [],
      volumNUm: null,
      isPickerShow1: false,
      isPickerShow2: false,
      favorites: [], // 选中包裹合单
      checkedall: false, // 是否全选
      total: 0.0, // 总计
      infiniteLoadData: {
        initialShowNum: 200, // 初始显示多少条
        everyLoadingNum: 200, // 每次加载的个数
        pullUpState: 4, // 子组件的pullUpState状态
        pullUpList: [], // 上拉加载更多数据的数组
        showPullUpListLength: this.initialShowNum, // 上拉加载后所展示的个数
      },
      isFinished: false,
      current: "0",
      pagenum: 1,
      indename: "0",
      list: [
        { packlist: [] },
        { packlist: [] },
        { packlist: [] },
        { packlist: [] },
      ],
      items: [
        { name: 0, label: "待入庫" },
        { name: 1, label: "已入庫" },
        { name: 2, label: "异常" },
        { name: 3, label: "歷史" },
      ],
      // 仓库列表
      warehouses: [
        {
          text: "",
          options: [],
        }, {
          text: "",
          options: [],
        },
      ],
      selected_wareHouse: "",
    };
  },
  activated() {
    localStorage.removeItem("serfren");
    if (
      localStorage.getItem("fleshpack") &&
      this.$route.query.id == undefined
    ) {
      this.pagenum = 1;
      this.parcelsimpleStatus(null);
    } else if (
      localStorage.getItem("fleshpack") &&
      this.$route.query.id != undefined
    ) {
      this.current = this.$route.query.packindecx;
      this.indename = this.$route.query.packindecx;
      this.pagenum = 1;
      this.parcelsimpleStatus(null);
    } else if (
      !localStorage.getItem("fleshpack") &&
      this.$route.query.id != undefined
    ) {
      if (this.current != this.$route.query.packindecx) {
        this.current = this.$route.query.packindecx;
        this.indename = this.$route.query.packindecx;
        this.pagenum = 1;
        this.parcelsimpleStatus(null);
      }
    }
  },

  methods: {
    handShow() {
      if (this.favorites.length) {
        this.isPickerShow1 = true
      } else {
        Toast.failed("请选择包裹");
      }
    },
    onPickerConfirm2({ value, text }) {
      this.volumNUm = value
      this.getjweigth();
      // this.showNetatye()
    },
    onPickerConfirm({ value, text }) {
      this.showCheck = value
      if (this.showCheck === 0) {
        this.volumList = []
        this.volumNUm = null
        this.showLinedata = []
        this.showNetatye()
      } else {
        Toast.loading("请稍等...");
        this.getVolumlist()
      }
      console.log('value', value)
    },
    showNetatye() {

      const newVal = this.list[1].packlist.filter(val => {
        return val.check
      })
      Toast.hide();
      this.total = this.sum(newVal);
    },
    getVolumlist() {
      let packlist = JSON.parse(JSON.stringify(this.list[1].packlist));
      const findval = packlist.filter(val => {
        return val.check
      });
      let par = {
        warehouseName: findval[0].warehouseName
      }
      this.http
        .APIASK(this.ports.getServicePriceVolumeDivision, "get", par)
        .then((res) => {
          this.volumList = res
          this.volumNUm = 0
          var list = []
          res.map((item, indx, arr) => {
            let obj = {
              text: item.productName,
              value: indx
            }
            list.push(obj)
          })
          this.showLinedata = list;
          this.getjweigth();

        })
        .catch((err) => {
          Toast.hide();
        });

    },
    //获取计抛数据
    getjweigth() {
      if (this.showCheck == 0) {
        this.showNetatye()
        return;
      }
      let pList = []
      let packlist = JSON.parse(JSON.stringify(this.list[1].packlist));
      const findval = packlist.filter(val => {
        return val.check
      });
      findval.map(val => {
        pList.push(val.expressNumber)
      })
      this.http.APIASK('/system/getParcelBillingWeight', 'post', { expressNumbers: pList, servicePriceName: this.volumList[this.volumNUm].productCode }).then(res => {
        console.log('resdata', res)
        for (let i = 0; i < res.length; i++) {
          for (let j = 0; j < packlist.length; j++) {
            if (res[i].expressNumber === packlist[j].expressNumber) {
              packlist[j].bulk = res[i].jWeight
              break;
            }
          }
        }
        this.list[1].packlist = packlist
        console.log('packlist', packlist)
        this.showNetatye()
      })

    },
    //设置渲染
    handCheck(index) {
      let packlist = JSON.parse(JSON.stringify(this.list[1].packlist));
      const findval = packlist.filter(val => {
        return val.check
      });
      let fidit = this.list[1].packlist[index];
      const findcheck = findval.filter(val => {
        return val.warehouse != fidit.warehouse
      });
      console.log('findcheck', findcheck)
      if (findcheck.length) {
        Toast.failed("不同倉庫的包裹不能合包");
      } else {
        this.list[1].packlist[index].check = !this.list[1].packlist[index].check
      }
      const newVal = this.list[1].packlist.filter(val => {
        return val.check
      })
      if ((newVal.length !== 0) && (newVal.length === this.list[1].packlist.length)) {
        this.checkedall = true;
      } else {
        this.checkedall = false;
      }
      if (newVal.length < 1) {
        this.showCheck = 0
        this.showLinedata = []
        this.volumNUm = null
      }
      this.favorites = newVal
      this.getjweigth()

      // this.total = this.sum(newVal);
      //
    },
    lanjie(item) {
      Dialog.confirm({
        content: "通知倉庫攔截並拒收該包裹，是否確認操作？",
        confirmText: "確定",
        onConfirm: () => this.parcelRejection(item.id),
      });
    },
    chenkjfr(item) {
      Dialog.confirm({
        content: "撤銷後包裹可以正常入庫，確定撤銷此拒收嗎？",
        confirmText: "確定",
        onConfirm: () => this.parcelCancelRejection(item.id),
      });
    },
    deletyichang(item) {
      Dialog.confirm({
        content: "删除後包裹將被隱藏，確認删除嗎？",
        confirmText: "確定",
        onConfirm: () => this.deltyi(item.id),
      });
    },
    deltyi(id) {
      const par = {
        id: id,
      };
      this.http
        .APIASK(this.ports.deleteException, "post", par)
        .then((res) => {
          this.parcelsimpleStatus(null);
        })
        .catch((err) => {
          Toast.hide();
        });
    },
    parcelCancelRejection(id) {
      const par = {
        id: id,
      };
      this.http
        .APIASK(this.ports.parcelCancelRejection, "get", par)
        .then((res) => {
          this.parcelsimpleStatus(null);
        })
        .catch((err) => {
          Toast.hide();
        });
    },
    parcelRejection(id) {
      const par = {
        id: id,
      };
      this.http
        .APIASK(this.ports.parcelRejection, "get", par)
        .then((res) => {
          this.parcelsimpleStatus(null);
        })
        .catch((err) => {
          Toast.hide();
        });
    },
    lookwu(item) {
      this.$router.push({
        name: "PackLogin",
        query: {
          expressNumber: item.expressNumber,
          expressCompany: item.expressCompany,
        },
      });
    },
    returnpack(item) {
      let usejr = []
      usejr[0] = item
      this.$router.push({
        name: "ReturnAddress",
        query: {
          des: JSON.stringify(usejr),
        },
      });
    },
    handReturn() {

      if (this.favorites.length < 1) {
        Toast.failed("请选择退货包裹");
        return
      }
      this.$router.push({
        name: "ReturnAddress",
        query: {
          des: JSON.stringify(this.favorites),
        },
      });
    },
    // 合并提交
    submit() {
      var json = this.favorites[0];
      var list = [];
      var item = this.favorites.map((val) => {
        if (json.warehouse != val.warehouse) {
          list.push(val);
        }
      });

      if (list.length > 0) {
        Toast.failed("不同倉庫的包裹不能合包");
        return;
      }
      this.ajcon
        .AJcon(this.ports.getMaxParcelNumByCountry, "post")
        .then((res) => {
          if (this.favorites.length > res) {
            Toast.failed("最大合包数不能超过" + res + "个");
          } else {
            Dialog.confirm({
              content: "您確定要合併發貨？",
              confirmText: "確定",
              onConfirm: () => this.allsubmit(),
            });
          }
          console.log(res);
        })
        .catch((err) => {
          Toast.hide();
        });
    },
    allsubmit() {
      var list = [];
      var item = this.favorites.map((val) => {
        list.push(val.id);
      });
      localStorage.setItem("addorder", 1);
      this.$router.push({
        name: "Orderpack",
        query: { ids: JSON.stringify(list) },
      });
    },
    // 全选
    checkall() {
      var list = [];
      this.list[1].packlist.map((val) => {
        if ((val.status == 12 || val.status == 13) && val.auditStatus != 0) {
          list.push(val);
        }
      });
      if (list.length) {
        let dataone = JSON.parse(JSON.stringify(list[0]))
        const findval = list.filter(val => {
          return val.warehouse != dataone.warehouse
        })
        if (findval.length) {
          Toast.failed("不同倉庫的包裹不能合包");
        } else {
          this.checkedall = !this.checkedall
          if (this.checkedall) {
            this.list[1].packlist.map(val => {
              if ((val.status == 12 || val.status == 13) && val.auditStatus != 0) {
                val.check = true
              }
            })
            const newVal = this.list[1].packlist.filter(val => {
              return val.check
            })
            this.favorites = newVal
            this.total = this.sum(newVal);
          } else {
            this.list[1].packlist.map(val => {
              if ((val.status == 12 || val.status == 13) && val.auditStatus != 0) {
                val.check = false
              }
            })
            const newVal = this.list[1].packlist.filter(val => {
              return val.check
            })
            console.log('newVal', newVal)
            if (newVal.length < 1) {
              this.volumList = [];
              this.volumNUm = null;
              this.showLinedata = [];
              this.showCheck = 0
            }
            this.favorites = newVal
            this.total = this.sum(newVal);
          }
        }
      }
    },

    parcelsimpleStatus(opear) {
      localStorage.removeItem("fleshpack");
      this.http
        .APIASK(this.ports.parcelsimpleStatus, "get")
        .then((res) => {
          res["0"] > 0
            ? (this.items[0].label = "待入庫" + res["0"])
            : (this.items[0].label = "待入庫"),
            res["1"] > 0
              ? (this.items[1].label = "已入庫" + res["1"])
              : (this.items[1].label = "已入庫"),
            res["2"] > 0
              ? (this.items[2].label = "异常" + res["2"])
              : (this.items[2].label = "异常"),
            res["3"] > 0
              ? (this.items[3].label = "歷史" + res["3"])
              : (this.items[3].label = "歷史"),
            this.getlist(opear);
        })
        .catch((err) => {
          Toast.hide();
        });
    },
    toserch() {
      this.$router.push({ name: "PackSearch" });
    },
    godetail(item) {
      this.$router.push({
        name: "Packdetail",
        query: { id: item.id, status: item.status },
      });
    },

    // tab切换
    changetable(item, index) {
      // 重置仓库选择
      this.selected_wareHouse = "";
      this.warehouses = [
        {
          text: "",
          options: [],
        }, {
          text: "",
          options: [],
        },
      ];
      this.current = item.name;
      this.pagenum = 1;
      this.volumList = [];
      this.volumNUm = null;
      this.showLinedata = [];
      this.showCheck = 0
      this.infiniteLoadData.pullUpList = [];
      this.infiniteLoadData.pullUpState = 4;
      this.parcelsimpleStatus(null);

    },
    delet(item, indx) {
      Dialog.confirm({
        content: "您確定要删除該包裹嗎",
        confirmText: "確定",
        onConfirm: () => {
          const par = {
            id: item.id,
          };
          this.http
            .APIASK(this.ports.parceldelete, "post", par)
            .then((res) => {
              this.parcelsimpleStatus(null);
              Toast.succeed("删除成功");
            })
            .catch((err) => {
            });
        },
      });
    },
    onRefreshone(done) {
      const scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      const scrollHeight =
        document.documentElement.clientHeight || document.body.scrollHeight;
      this.showCheck = 0
      this.volumList = [];
      this.volumNUm = null;
      if (this.infiniteLoadData.pullUpState === 0) {
        this.infiniteLoadData.pullUpList = [];
        this.pagenum = 1;
        this.parcelsimpleStatus(null);
        done();
      } else {
        done();
        this.infiniteLoadData.pullUpState = 0;
      }
    },
    // 上拉加载
    infinite(done) {
      if (this.infiniteLoadData.pullUpState === 1) {
        this.pagenum++;
        this.getlist("load");
        done();
      } else {
        done();
        this.infiniteLoadData.pullUpState = 0;
      }
    },
    changeWareHouse(barItem, listItem) {
      Toast.loading("请稍等...");
      if (listItem.value != '') {
        if (isNaN(parseInt(listItem.value))) {
          this.selected_wareHouse = listItem.value;

        } else {
          this.inStatus = listItem.value
        }
      } else {
        this.inStatus = ''
      }
      this.getlist();
    },

    getlist(opear) {
      this.infiniteLoadData.pullUpState = 0;
      const par = {
        keyword: "",
        pageNum: this.pagenum,
        pageSize: 200,
        sort: false,
        status: this.current,
        inStatus: this.inStatus,
        warehouse: this.selected_wareHouse
          ? this.selected_wareHouse
          : undefined,
      };
      this.http
        .APIASK(this.ports.parcellist, "get", par)
        .then((res) => {
          Toast.hide();
          // pullUpState: 0, 1:上拉加载更多, 2:加载中……, 3:我是有底线的
          if (opear) {
            // console.log("上拉加载")
            if (res.list.length > 0) {
              this.list[this.current].packlist = this.list[
                this.current
              ].packlist.concat(res.list);
              this.infiniteLoadData.pullUpList =
                this.list[this.current].packlist;
              if (res.list.length < 200) {
                this.infiniteLoadData.pullUpState = 3;
              } else {
                this.infiniteLoadData.pullUpState = 1;
              }
            } else {
              this.infiniteLoadData.pullUpState = 3;
            }
          } else {
            // console.log("下拉刷新")
            this.checkedall = false;
            this.total = 0.0;
            this.favorites = [];
            this.showCheck = 0;
            this.volumList = [];
            this.volumNUm = null;
            const listData = res.list;
            listData.map(val => {
              val.check = false
            })
            if (listData.length < 200) {
              this.infiniteLoadData.pullUpState = 3;
            } else {
              this.infiniteLoadData.pullUpState = 1;
            }
            this.list[this.current].packlist = listData;
            // console.log(
            //   this.infiniteLoadData.pullUpState,
            //   this.list[this.current].packlist
            // );
            this.infiniteLoadData.pullUpList = this.list[this.current].packlist;
          }
          this.list[this.current].packlist.length < 200
            ? (this.infiniteLoadData.pullUpState = 0)
            : null;

          // 仓库筛选
          let list = [
            {
              text: "仓库筛选",
              options: [
                {
                  value: undefined,
                  text: "全部",
                },
              ],
            },
            {
              text: "全部",
              options: [
                {
                  value: '',
                  text: "全部",
                },
                {
                  value: '11',
                  text: "待补完",
                }, {
                  value: '12',
                  text: "待合包",
                }, {
                  value: '13',
                  text: "超期",
                },
              ],
            },
          ];
          for (let i in res.warehouses) {
            let arr = {
              value: res.warehouses[i],
              text: res.warehouses[i],
            };
            list[0].options.push(arr);
          }
          this.warehouses = list;

          Toast.hide();
        })
        .catch((err) => {
          Toast.hide();
        });
    },
    detail(item) {
      this.$router.push({
        name: "Predition",
        query: { id: item.countryId, item: JSON.stringify(item) },
      });
    },
    sum(list) {
      var weight = 0;
      var showType = this.showCheck
      var volumList = JSON.parse(JSON.stringify(this.volumList))
      var cheNUme = this.volumNUm

      if (showType === 1 && volumList[cheNUme].isBubbles === 1) {
        list.some(item => {
          weight += item.bulk
        });
      } else {
        list.some(item => {
          weight += item.realWeight
        });
      }
      return weight.toFixed(2);
    },
    getStartPullUpState() {
      if (this.infiniteLoadData.pullUpList.length) {
        if (
          this.list[this.current].packlist.length <=
          this.infiniteLoadData.initialShowNum
        ) {
          // 修改子组件的pullUpState状态
          this.infiniteLoadData.pullUpState = 3;
        } else {
          this.infiniteLoadData.pullUpState = 1;
        }
      } else {
        this.infiniteLoadData.pullUpState = 0;
      }
    },
    toprediction() {
      this.$router.push({
        name: "Predition",
        query: {
          id: JSON.parse(localStorage.getItem("userinfoMobie")).disVo.id,
        },
      });
    },
  },
  mounted() {
    this.$refs.search.message = "快遞單號";
    this.parcelsimpleStatus(null);
  },
};
</script>

<style lang="less">
.packPage {

  .md-tab-bar {
    position: fixed;
    top: 1rem;
    z-index: 999;
    width: 100%;
    padding: 0;
    font-size: 0.24rem;
  }

  .md-tab-bar-item.is-active {
    color: #e32c1a;
  }

  .md-tab-bar-ink {
    background-color: #e32c1a;
  }

  .packItem {
    background-color: rgba(255, 255, 255, 1);
    color: rgba(16, 16, 16, 1);
    box-shadow: 2px 2px 7px 2px rgba(207, 207, 207, 0.5);
    margin-bottom: 0.1rem;
    border-radius: 0.1rem;
    width: 94%;
    margin-left: 3%;

    .packcompany {
      width: 100%;
      height: 0.6rem;
      display: flex;
      align-items: center;
      font-size: 0.26rem;
      justify-content: space-between;


      .packtitle {
        height: 100%;
        display: flex;
        align-items: center;
        padding-left: 0.3rem;

        img {
          width: 0.3rem;
          margin: 0 0.1rem;
        }
      }

      span {
        margin-right: 0.1rem;
      }
    }

    .pckdetail {
      padding: 0 0.2rem;
      font-size: 0.28rem;

      p {
        text-align: left;
        text-align: left;

        span {}
      }
    }

    .fidays {
      p {
        margin-bottom: 0.1rem;
      }
    }

    .packopeartion {
      width: 100%;
      height: 0.6rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-bottom: 0.1rem;

      .appbutone {
        border-radius: 0.3rem;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 1.1rem;
        height: 0.5rem;
        font-size: 0.22rem;
        border: 0.02rem solid #888888;
        margin-right: 0.15rem;
      }
    }
  }

  .packageTyp {
    height: 0.3rem;
    padding: 0.03rem 0.08rem;
    border-radius: 0.07rem;
    font-size: 0.2rem;
    color: rgba(255, 255, 255, 1);
    background-color: #81B337;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 0.2rem 0 0;

    span {
      margin: 0 !important;
    }
  }

  .goodtypecontaiher {
    display: flex;
    align-items: center;
  }

  .packageTyps {
    height: 0.3rem;
    padding: 0 0.18rem;
    border-radius: 0.07rem;
    font-size: 0.2rem;
    color: #307dfd;
    border: 1px solid #307dfd;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      margin: 0 !important;
    }
  }

  .checkbtn {
    margin-left: 0.2rem;

    .md-check-icon {
      font-size: 0.7rem;
    }
  }

  .fixchedk {
    position: fixed;
    width: 100%;
    height: 0.8rem;
    bottom: 2.2rem;
    background-color: #fcedea !important;
    display: flex;
    align-items: center;
    border-top: 1px solid #e64340;

    .checkView {
      width: 1.4rem;
      height: 70%;
      background: white;
      display: flex;
      justify-content: space-between;
      padding: 0 0.1rem;
      font-size: 0.26rem;
      align-items: center;
      margin-left: 0.2rem;
      border-radius: 0.08rem;
    }

    .shotips {
      font-size: 0.24rem;
      margin-left: 0.3rem;
    }

    .jifensjer {
      width: 2.5rem;
      height: 70%;
      background: white;
      display: flex;
      justify-content: space-between;
      padding: 0 0.1rem;
      font-size: 0.26rem;
      align-items: center;
      margin-left: 0.2rem;
      border-radius: 0.08rem;
    }
  }

  .bottomView {
    position: fixed;
    width: 100%;
    height: 1rem;
    bottom: 1rem;
    margin-bottom: 0.2rem;
    background-color: white !important;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .checkall {
      height: 100%;
      display: flex;
      align-items: center;
      width: 17%;
      margin-left: 3%;

      span {
        margin-left: 0.1rem;
        font-size: 0.26rem;
        font-weight: 500;
      }
    }

    .chelist {
      width: 80%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .cancle {
      font-size: 0.22rem;
      height: 70%;

      p {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-around;
        color: #666666;

        .money {
          color: #e51c23;
          font-size: 0.24rem;
          font-weight: 500;
        }
      }
    }
  }

  .parcel_detail_container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 0.1rem;

    .tag_container {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      font-size: 0.2rem;
      border-radius: 0.2rem;

      .usnenr {
        margin-right: 0.1rem;
        margin-bottom: 0.05rem;
        margin-top: 0.05rem;
        padding: 0.03rem 0.12rem;
        border-radius: 0.8rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #bbbbbb;
        color: #666666;
        font-size: 0.18rem;
      }

      .md-tag {
        margin-left: 0.1rem;
      }
    }
  }

  // 仓库筛选下拉
  .contentpack .md-drop-menu {
    height: auto;
    box-sizing: border-box;
    color: #666f83;
    font-size: 0.3rem;
    font-weight: 500;
    position: relative;
    margin: 0 0.2rem 0.1rem 0.2rem;
    text-align: right;

    .md-drop-menu-list {
      padding-top: 0.65rem !important;
    }

    .md-popup {
      top: 1rem !important;
    }

    .md-drop-menu-bar .bar-item.selected {
      color: #e51c23 !important;
    }
  }
}
</style>
